import React from 'react';

const checkmarkSvg = (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <circle cx="14" cy="14" r="13" fill="none" />
    <path d="M8 15.5L13 20.5L20 11.5" stroke="#2d3a8c" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

function PillSelector({
  options = [],
  value,
  onChange,
  multiSelect = false,
  disabled = false,
  className = '',
  style = {},
}) {
  // Normalize value for multi/single select
  const selected = multiSelect ? (Array.isArray(value) ? value : []) : value;

  const handleClick = (optionValue) => {
    if (disabled) return;
    if (multiSelect) {
      if (selected.includes(optionValue)) {
        onChange(selected.filter((v) => v !== optionValue));
      } else {
        onChange([...selected, optionValue]);
      }
    } else {
      if (selected === optionValue) {
        onChange(''); // allow deselect
      } else {
        onChange(optionValue);
      }
    }
  };

  return (
    <div className={`pill-selector-root ${className}`} style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', ...style }}>
      {options.map((opt) => {
        const isSelected = multiSelect ? selected.includes(opt.value) : selected === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            className={`pill-selector-pill${isSelected ? ' selected' : ''}`}
            onClick={() => handleClick(opt.value)}
            disabled={disabled || opt.disabled}
            aria-pressed={isSelected}
            tabIndex={0}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 0,
              borderRadius: '999px',
              border: isSelected ? '2px solid #2d3a8c' : '2px solid #bfc6d1',
              background: isSelected ? 'rgba(45, 58, 140, 0.10)' : '#fff',
              color: '#222',
              fontWeight: 500,
              fontSize: '1rem',
              padding: '7px 18px',
              cursor: disabled || opt.disabled ? 'not-allowed' : 'pointer',
              outline: isSelected ? '2px solid #2d3a8c' : 'none',
              boxShadow: isSelected ? '0 2px 8px rgba(45,58,140,0.08)' : 'none',
              transition: 'all 0.15s',
              minWidth: 70,
              minHeight: 34,
              opacity: disabled || opt.disabled ? 0.6 : 1,
              position: 'relative',
            }}
          >
            {isSelected && (
              <span style={{
                width: 20,
                height: 20,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: 0,
                flexShrink: 0,
              }}>
                {checkmarkSvg}
              </span>
            )}
            <span>{opt.label}</span>
          </button>
        );
      })}
      <style>{`
        .pill-selector-pill:focus {
          outline: 2px solid #2d3a8c;
        }
        .pill-selector-pill.selected {
          color: #2d3a8c;
          background: rgba(45, 58, 140, 0.10);
          border-color: #2d3a8c;
        }
        .pill-selector-pill:not(.selected):hover {
          border-color: #2d3a8c;
        }
      `}</style>
    </div>
  );
}

export default PillSelector;

